<template>
  <div>
    <div
      v-if="!isNoInvoice"
      id="invoice"
      class="mt-4"
    >
      <table
        width="100%"
        border="0"
        cellpadding="0"
        cellspacing="0"
        align="center"
        class="fullTable"
      >
        <tr>
          <td>
            <table
              width="600"
              border="0"
              cellpadding="0"
              cellspacing="0"
              align="center"
              class="fullTable"
              bgcolor="#ffffff"
              style="border-radius: 10px 10px 0 0;"
            >
              <tr>
                <td>
                  <table
                    width="480"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    align="center"
                    class="fullPadding"
                  >
                    <tbody>
                      <tr>
                        <td>
                          <table
                            width="100%"
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            align="right"
                          >
                            <tbody>
                              <tr />
                              <tr />
                              <tr class="hiddenMobile">
                                <td height="50" />
                              </tr>
                              <tr class="visibleMobile">
                                <td height="20" />
                              </tr>
                              <tr>
                                <td
                                  style="font-size: 21px; color: #ff0000; letter-spacing: -1px; font-family: 'Open Sans', sans-serif; line-height: 1; vertical-align: top; text-align: left;"
                                >
                                  <table
                                    width="220"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    align="right"
                                    class="col"
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          style="font-size: 16px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; line-height: 1; vertical-align: top; "
                                        >
                                          <strong>{{ invoice.from.company.name }}</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          width="100%"
                                          height="10"
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; line-height: 20px; vertical-align: top; "
                                        >
                                          ABN Number: {{ invoice.from.company.abn_number }},<br>
                                          {{ invoice.from.company.address.line1 }}<br>{{
                                            invoice.from.company.address.city }}, {{ invoice.from.company.address.state
                                          }}<br>
                                          PIN : {{ invoice.from.company.address.postal_code }}
                                          <br>Phone: {{ invoice.from.company.phone_number }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td
                                  style="font-size: 12px; color: #5b5b5b; font-family: 'Open Sans', sans-serif; line-height: 18px; vertical-align: top; text-align: right!important;"
                                >
                                  <table
                                    width="220"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    align="right"
                                    class="col"
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          style="font-size: 21px; color: #ff0000; letter-spacing: -1px; font-family: 'Open Sans', sans-serif; line-height: 1; vertical-align: top; text-align: right!important;"
                                        >
                                          <strong>INVOICE</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          width="100%"
                                          height="10"
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; line-height: 10px; vertical-align: top; text-align: right!important;"
                                        >
                                          <small>Invoice No. {{ invoice.invoice_number }}</small> <br>
                                          <small> Invoice Date {{ invoice.issue_date }}</small><br>
                                          <small> Due Date {{ invoice.due_date }}</small>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <table
        width="100%"
        border="0"
        cellpadding="0"
        cellspacing="0"
        align="center"
        class="fullTable"
      >
        <tbody>
          <tr>
            <td>
              <table
                width="600"
                border="0"
                cellpadding="0"
                cellspacing="0"
                align="center"
                class="fullTable"
                bgcolor="#ffffff"
              >
                <tbody>
                  <tr />
                  <tr class="hiddenMobile">
                    <td height="30" />
                  </tr>
                  <tr class="visibleMobile">
                    <td height="20" />
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="480"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        align="center"
                        class="fullPadding"
                      >
                        <tbody>
                          <tr>
                            <td class="side-to-side">
                              <table
                                width="220"
                                border="0"
                                cellpadding="0"
                                cellspacing="0"
                                align="left"
                                class="col"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      style="font-size: 11px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; line-height: 1; vertical-align: top; "
                                    >
                                      <strong>BILLING TO</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      width="100%"
                                      height="10"
                                    />
                                  </tr>
                                  <tr>
                                    <td
                                      style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; line-height: 20px; vertical-align: top; "
                                    >
                                      {{ invoice.to.name }}<br>
                                      {{ invoice.to.address.line1 }}<br>{{ invoice.to.address.city }}, {{
                                        invoice.to.address.state }}<br>
                                      PIN: {{ invoice.to.address.postal_code }}
                                      <br>Phone: {{ invoice.to.phone_number }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr class="hiddenMobile">
                    <td height="60" />
                  </tr>
                  <tr class="visibleMobile">
                    <td height="30" />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="100%"
        border="0"
        cellpadding="0"
        cellspacing="0"
        align="center"
        class="fullTable"
        bgcolor="#e1e1e1"
      >
        <tbody>
          <tr>
            <td>
              <table
                width="600"
                border="0"
                cellpadding="0"
                cellspacing="0"
                align="center"
                class="fullTable"
                bgcolor="#ffffff"
              >
                <tbody>
                  <tr />
                  <tr class="hiddenMobile">
                    <td height="60" />
                  </tr>
                  <tr class="visibleMobile">
                    <td height="40" />
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="480"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        align="center"
                        class="fullPadding"
                      >
                        <tbody>
                          <tr>
                            <th
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; font-weight: normal; line-height: 1; vertical-align: top; padding: 0 10px 7px 0;"
                              width="52%"
                              align="left"
                            >
                              Item
                            </th>
                            <th
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; font-weight: normal; line-height: 1; vertical-align: top; padding: 0 0 7px;"
                              align="left"
                            >
                              <small>Unit Price</small>
                            </th>
                            <th
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; font-weight: normal; line-height: 1; vertical-align: top; padding: 0 0 7px;"
                              align="center"
                            >
                              Quantity
                            </th>
                            <th
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #1e2b33; font-weight: normal; line-height: 1; vertical-align: top; padding: 0 0 7px;"
                              align="right"
                            >
                              Subtotal
                            </th>
                          </tr>
                          <tr>
                            <td
                              height="1"
                              style="background: #bebebe;"
                              colspan="4"
                            />
                          </tr>
                          <tr>
                            <td
                              height="10"
                              colspan="4"
                            />
                          </tr>
                          <tr
                            v-for="(item, index) in invoice.line_items"
                            :key="index"
                          >
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #ff0000;  line-height: 18px;  vertical-align: top; padding:10px 0;"
                              class="article"
                            >
                              {{ item.itemName }}
                            </td>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #646a6e;  line-height: 18px;  vertical-align: top; padding:10px 0;"
                            >
                              <small>$ {{ item.unitPrice }}</small>
                            </td>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #646a6e;  line-height: 18px;  vertical-align: top; padding:10px 0;"
                              align="center"
                            >
                              {{ item.quantity }}
                            </td>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #1e2b33;  line-height: 18px;  vertical-align: top; padding:10px 0;"
                              align="right"
                            >
                              {{ item.amount }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              height="1"
                              colspan="4"
                              style="border-bottom:1px solid #e4e4e4"
                            />
                          </tr>
                          <tr>
                            <td
                              height="1"
                              colspan="4"
                              style="border-bottom:1px solid #e4e4e4"
                            />
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td height="20" />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="100%"
        border="0"
        cellpadding="0"
        cellspacing="0"
        align="center"
        class="fullTable"
      >
        <tbody>
          <tr>
            <td>
              <table
                width="600"
                border="0"
                cellpadding="0"
                cellspacing="0"
                align="center"
                class="fullTable"
                bgcolor="#ffffff"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        width="480"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        align="center"
                        class="fullPadding"
                      >
                        <tbody>
                          <tr>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #646a6e; line-height: 22px; vertical-align: top; text-align:right; "
                            >
                              Subtotal
                            </td>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #646a6e; line-height: 22px; vertical-align: top; text-align:right; white-space:nowrap;"
                              width="80"
                            >
                              ${{ calculateSubTotal }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #646a6e; line-height: 22px; vertical-align: top; text-align:right; "
                            >
                              GST (10%)
                            </td>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #646a6e; line-height: 22px; vertical-align: top; text-align:right; "
                            >
                              ${{ calculateGst }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #000; line-height: 22px; vertical-align: top; text-align:right; "
                            >
                              <strong>Grand Total (Incl.Tax)</strong>
                            </td>
                            <td
                              style="font-size: 12px; font-family: 'Open Sans', sans-serif; color: #000; line-height: 22px; vertical-align: top; text-align:right; "
                            >
                              <strong>${{ invoice.amount }}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="100%"
        border="0"
        cellpadding="0"
        cellspacing="0"
        align="center"
        class="fullTable"
      >
        <tr>
          <td>
            <table
              width="600"
              border="0"
              cellpadding="0"
              cellspacing="0"
              align="center"
              class="fullTable"
              bgcolor="#ffffff"
              style="border-radius: 0 0 10px 10px;"
            >
              <tr />
              <tr class="spacer">
                <td height="50" />
              </tr>
              <tr>
                <td
                  style="font-size: 10px; color: #5b5b5b; font-family: 'Open Sans', sans-serif; line-height: 18px; vertical-align: top; text-align: center;"
                >
                  Thank you for your business
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td height="20" />
        </tr>
      </table>
    </div>
    <div class="btn-container">
      <v-btn
        small
        color="#64CA7F"
        class="btn-style"
        elevation="0"
        @click="generateInvoice"
      >
        Generate Invoice
      </v-btn>

      <v-btn
        small
        color="#e2e2e2"
        class="btn-style"
        elevation="0"
        light
        @click="cancelInvoice"
      >
        Cancel
      </v-btn>
    </div>

    <br>
    <br>
    <br>
    <br>
    <v-overlay
      v-if="invoiceLoader"
      :absolute="absolute"
      :value="overlay"
    >
      <div class="loader" />
    </v-overlay>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import Constants from 'src/constants';
export default {
  name: 'InvoiceTemplate',
  data () {
    return {
      pdfData: null,
      absolute: false,
      overlay: true,
      invoiceLoader: false,
    };
  },
  computed: {
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    invoiceCreated () {
      return this.$store.getters['invoice/getInvoice'];
    },
    invoiceDrafted () {
      return this.$store.getters['invoice/getInvoiceDetails'];
    },
    invoice () {
      if (this.$route.path.includes('/generate')) {
        return this.invoiceCreated;
      }
      return this.invoiceDrafted;
    },
    isNoInvoice () {
      if (Object.keys(this.invoice).length === 0) {
        return true;
      }
      return false;
    },
    calculateSubTotal () {
      var subTotal = 0;
      this.invoice.line_items.filter((item) => {
        subTotal = subTotal + item.amount;
      });
      return subTotal;
    },
    calculateGst () {
      return (this.calculateSubTotal * 10) / 100;
    },
  },
  mounted () {
    this.loadOnMount();
  },
  methods: {
    loadOnMount () {
      if (this.isNoInvoice) {
        this.$router.push({ name: 'Invoices' });
      }
    },
    async generateInvoice () {
      this.invoiceLoader = true;
      const element = document.getElementById('invoice');
      const options = {
        margin: 1,
        filename: 'Invoice_INV001.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      };

      // Generate PDF as Blob and upload
      const pdfBlob = await html2pdf().set(options).from(element).toPdf().output('blob');
      const formData = new FormData();
      formData.append('document_file', pdfBlob, `Invoice ${this.invoice.invoice_number}.pdf`);
      formData.append('invoice_id', this.invoice.id);
      formData.append('status', 'pending');
      await this.$store.dispatch('invoice/uploadInvoice', {
        document: formData,
        orgExtId: this.selectedOrganization.organization.external_id,
      },
      ).then((res) => {
        this.invoiceLoader = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Invoice generated successfully',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.$router.push({ name: 'Invoices' });
      })
      .catch(() => {
        this.invoiceLoader = false;
      });
    },
    cancelInvoice () {
      this.$router.push({ name: 'Invoices' });
    },
  },
};
</script>

<style scoped>
#invoice {
  font-family: Arial, sans-serif;
  max-width: 100%;
  margin: 0 auto;
  background-color: #fff;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');

/* * {
  font-family: "DM Sans", serif;
} */

.address {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
}

.header {
  background: linear-gradient(90deg, rgba(0, 86, 231, 1) 0%, rgba(255, 0, 18, 1) 99%);
  color: #fff;
  padding: 15px;
}

@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,700);

div,
p,
a,
li,
td {
  -webkit-text-size-adjust: none;
}

.ReadMsgBody {
  width: 100%;
  background-color: #ffffff;
}

.ExternalClass {
  width: 100%;
  background-color: #ffffff;
}

html {
  width: 100%;
}

p {
  padding: 0 !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
}

.side-to-side {
  display: flex;
}

.visibleMobile {
  display: none;
}

.hiddenMobile {
  display: block;
}

@media only screen and (max-width: 600px) {
  body {
    width: auto !important;
  }

  table[class=fullTable] {
    width: 96% !important;
    clear: both;
  }

  table[class=fullPadding] {
    width: 100% !important;
    clear: both;
  }

  table[class=col] {
    width: 45% !important;
  }

  .erase {
    display: none;
  }
}

@media only screen and (max-width: 420px) {
  table[class=fullTable] {
    width: 100% !important;
    clear: both;
  }

  table[class=fullPadding] {
    width: 100% !important;
    clear: both;
  }

  table[class=col] {
    width: 100% !important;
    clear: both;
  }

  table[class=col] td {
    text-align: left !important;
  }

  .erase {
    display: none;
    font-size: 0;
    max-height: 0;
    line-height: 0;
    padding: 0;
  }

  .visibleMobile {
    display: block !important;
  }

  .hiddenMobile {
    display: none !important;
  }
}

@media screen and (max-width: 600px) {
  #invoice {
    padding: 8px;
  }

  table {
    font-size: 12px;
  }

}

/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  display: flex;
  color: #ffffff;
  background:
    linear-gradient(currentColor 0 0) right /51% 100%,
    linear-gradient(currentColor 0 0) bottom /100% 51%;
  background-repeat: no-repeat;
  animation: l16-0 2s infinite linear .25s;

}

.loader::before {
  content: "";
  width: 50%;
  height: 50%;
  background: currentColor;
  animation: l16-1 .5s infinite linear;
  border: 1px dashed #ff3700;
}

@keyframes l16-0 {

  0%,
  12.49% {
    transform: rotate(0deg)
  }

  12.5%,
  37.49% {
    transform: rotate(90deg)
  }

  37.5%,
  62.49% {
    transform: rotate(180deg)
  }

  62.5%,
  87.49% {
    transform: rotate(270deg)
  }

  87.5%,
  100% {
    transform: rotate(360deg)
  }
}

@keyframes l16-1 {
  0% {
    transform: perspective(80px) rotate3d(-1, -1, 0, 0)
  }

  80%,
  100% {
    transform: perspective(80px) rotate3d(-1, -1, 0, -180deg)
  }
}
.btn-container{
 padding-top:20px;
}
</style>
